module.exports = __webpack_public_path__ + "img/story1.5171a6df.png";